import { render, staticRenderFns } from "./course_stu.vue?vue&type=template&id=feebb29c&scoped=true&"
import script from "./course_stu.vue?vue&type=script&lang=js&"
export * from "./course_stu.vue?vue&type=script&lang=js&"
import style0 from "./course_stu.vue?vue&type=style&index=0&id=feebb29c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feebb29c",
  null
  
)

export default component.exports